import Lottie from 'lottie-web'

import a11yPreferences from '../helpers/a11yPreferences'
import hasHoverState from '../helpers/hasHoverState'
import ee from '../ee'

function initServiceAnimation(el) {
  let animation = Lottie.loadAnimation({
    container: el,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: `/animations/${el.dataset.lottieName}.json`,
  })

  if (!hasHoverState()) {
    return
  }

  let hoverElement = el.closest('.service-card') || el

  function onFocus() {
    animation.setDirection(1)
    animation.setSpeed(a11yPreferences.reducedMotion ? Infinity : 2)
    animation.play()
  }

  function onBlur() {
    animation.setDirection(-1)
    animation.setSpeed(a11yPreferences.reducedMotion ? Infinity : 3)
    animation.play()
  }

  hoverElement.addEventListener('mouseenter', onFocus)
  hoverElement.addEventListener('focus', onFocus)
  hoverElement.addEventListener('mouseleave', onBlur)
  hoverElement.addEventListener('blur', onBlur)
}

function initLoopingAnimation(el) {
  Lottie.loadAnimation({
    container: el,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: `/animations/${el.dataset.lottieName}.json`,
  })
}

function initServiceAnimations() {
  let els_service_animations = document.querySelectorAll(
    '.js-lottie-anim-service'
  )
  els_service_animations.forEach(initServiceAnimation)
}

function initLoopingAnimations() {
  let els_looping_animations = document.querySelectorAll(
    '.js-lottie-anim-looping'
  )
  els_looping_animations.forEach(initLoopingAnimation)
}

function init() {
  initServiceAnimations()
  initLoopingAnimations()
}

ee.addListener('initComponents', init)
